"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSearchControl = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var autocomplete_1 = require("../api/calls/google/autocomplete");
var lodash_1 = require("lodash");
var AddressSearchControl = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Location" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "Search for an address" : _c, value = _a.value, onSelectionChange = _a.onSelectionChange, _d = _a.error, error = _d === void 0 ? false : _d, _e = _a.helperText, helperText = _e === void 0 ? "" : _e, _f = _a.backgroundColor, backgroundColor = _f === void 0 ? "white" : _f, letsTradeAPIUrl = _a.letsTradeAPIUrl, labelColor = _a.labelColor, textColor = _a.textColor;
    var _g = (0, react_1.useState)(false), open = _g[0], setOpen = _g[1];
    var _h = (0, react_1.useState)([]), options = _h[0], setOptions = _h[1];
    var _j = (0, react_1.useState)(false), loading = _j[0], setLoading = _j[1];
    var _k = (0, react_1.useState)(""), inputValue = _k[0], setInputValue = _k[1];
    var _l = (0, react_1.useState)(null), selectedValue = _l[0], setSelectedValue = _l[1];
    // Sync internal state with prop value
    (0, react_1.useEffect)(function () {
        if (value === null || value === void 0 ? void 0 : value.fullAddress) {
            setSelectedValue({ description: value.fullAddress });
            setInputValue(value.fullAddress);
        }
    }, [value]);
    var fetchPredictions = (0, react_1.useMemo)(function () {
        return (0, lodash_1.debounce)(function (input, callback) { return __awaiter(void 0, void 0, void 0, function () {
            var response, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, autocomplete_1.autocomplete)(input)];
                    case 1:
                        response = _b.sent();
                        if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) {
                            callback(response.data.content);
                        }
                        else {
                            callback([]);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        //                     console.error(err);
                        callback([]);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 400);
    }, []);
    (0, react_1.useEffect)(function () {
        var active = true;
        if (inputValue === "") {
            setOptions(selectedValue ? [selectedValue] : []);
            return undefined;
        }
        if (inputValue.length < 3) {
            return undefined;
        }
        setLoading(true);
        fetchPredictions(inputValue, function (results) {
            if (active) {
                var newOptions = [];
                if (selectedValue) {
                    newOptions = [selectedValue];
                }
                if (results) {
                    newOptions = __spreadArray(__spreadArray([], newOptions, true), results, true);
                }
                setOptions(newOptions);
                setLoading(false);
            }
        });
        return function () {
            active = false;
        };
    }, [inputValue, fetchPredictions]);
    return (react_1.default.createElement(material_1.Autocomplete, { id: "google-address-search", sx: {
            width: "100%",
            backgroundColor: backgroundColor,
            "& .MuiOutlinedInput-root": {
                borderRadius: "0.75rem",
                // Default border
                "& fieldset": {
                    borderColor: "black",
                },
                // Hover border
                "&:hover fieldset": {
                    borderColor: "black",
                },
                // Focused border
                "&.Mui-focused fieldset": {
                    borderColor: "black",
                },
            },
            "& .MuiInputLabel-root": {
                color: labelColor ? labelColor.replace("text-", "") : "inherit",
            },
            "& .MuiInputLabel-root.Mui-focused": {
                color: labelColor ? labelColor.replace("text-", "") : "black",
            },
            "& .MuiInputBase-input": {
                color: textColor ? textColor.replace("text-", "") : "inherit",
            },
        }, open: open, onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); }, isOptionEqualToValue: function (option, value) { return option.description === value.description; }, getOptionLabel: function (option) { return option.description || ""; }, options: options, loading: loading, value: selectedValue, filterOptions: function (x) { return x; }, onChange: function (event, newValue) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setOptions(newValue ? __spreadArray([newValue], options, true) : options);
                setSelectedValue(newValue);
                if (newValue === null || newValue === void 0 ? void 0 : newValue.place_id) {
                    onSelectionChange({
                        fullAddress: newValue.description,
                        place_id: newValue.place_id,
                        coordinates: {
                            lat: "0",
                            lng: "0",
                        },
                        google_place: newValue,
                    });
                }
                else if (newValue === null) {
                    onSelectionChange({
                        fullAddress: "",
                        place_id: "",
                        coordinates: {
                            lat: "0",
                            lng: "0",
                        },
                        google_place: null,
                    });
                }
                return [2 /*return*/];
            });
        }); }, onInputChange: function (event, newInputValue) {
            setInputValue(newInputValue);
        }, renderInput: function (params) { return (react_1.default.createElement(material_1.TextField, __assign({}, params, { label: label, placeholder: placeholder, error: error, helperText: helperText, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                    loading ? react_1.default.createElement(material_1.CircularProgress, { color: "inherit", size: 20 }) : null,
                    params.InputProps.endAdornment)) }), sx: {
                width: "100%",
                backgroundColor: backgroundColor,
                "& .MuiOutlinedInput-root": {
                    borderRadius: "0.75rem",
                    // Default border
                    "& fieldset": {
                        borderColor: "black",
                    },
                    // Hover border
                    "&:hover fieldset": {
                        borderColor: "black",
                    },
                    // Focused border
                    "&.Mui-focused fieldset": {
                        borderColor: "black",
                    },
                },
                "& .MuiInputLabel-root": {
                    color: labelColor ? labelColor.replace("text-", "") : "inherit",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                    color: labelColor ? labelColor.replace("text-", "") : "black",
                },
                "& .MuiInputBase-input": {
                    color: textColor ? textColor.replace("text-", "") : "inherit",
                },
            } }))); } }));
};
exports.AddressSearchControl = AddressSearchControl;
